var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-google 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6794 10.3819L22.5734 9.93234H12.8028V14.0677H18.6406C18.0345 16.9458 15.222 18.4608 12.9247 18.4608C11.2531 18.4608 9.49109 17.7577 8.32484 16.6275C7.70953 16.0217 7.21974 15.3005 6.88353 14.5051C6.54731 13.7098 6.37126 12.856 6.36547 11.9925C6.36547 10.2506 7.14828 8.50828 8.28734 7.36219C9.42641 6.21609 11.1467 5.57484 12.8572 5.57484C14.8161 5.57484 16.22 6.615 16.745 7.08938L19.6836 4.16625C18.8216 3.40875 16.4534 1.5 12.7625 1.5C9.91484 1.5 7.18437 2.59078 5.18844 4.58016C3.21875 6.53906 2.19922 9.37172 2.19922 12C2.19922 14.6283 3.16391 17.3194 5.07266 19.2938C7.11219 21.3994 10.0006 22.5 12.9748 22.5C15.6809 22.5 18.2459 21.4397 20.0741 19.5159C21.8713 17.6222 22.8008 15.0019 22.8008 12.255C22.8008 11.0986 22.6845 10.4119 22.6794 10.3819Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.61bd3e5f74d26cebb1436f1b02318f07.svg";
export { ForwardRef as ReactComponent };